<template>
    <div class="bottom">
        <div class="bottom-box"></div>
    </div>
</template>

<script>
    export default {
        name: "homeBotton"
    }
</script>

<style scoped lang="scss">
    .bottom{
        width: 100vw;
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: center;
        z-index: 999;
        .bottom-box{
            width: 64vw;
            height: 5.5vh;
            background: url("../assets/img/bottom.png");
            background-size: 100% 100%;
        }
    }
</style>